import {Injectable} from '@angular/core';
import {APIRequest, APIRequestResources, PaginationResponse} from "../../../../../core";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {BehaviorSubject, Subject, tap} from "rxjs";
import {toSignal} from "@angular/core/rxjs-interop";
import {ContactPersonDTO, ContactPersonFindDTO} from "../interfaces/contact-person.entity";

@Injectable({
    providedIn: 'root'
})
export class ContactPersonService extends APIRequest {
    private readonly $all = new BehaviorSubject<ContactPersonFindDTO[]>([]);
    all = toSignal(this.$all, { initialValue: [] })

    private readonly $active = new BehaviorSubject<ContactPersonDTO | undefined>(undefined);
    active = toSignal(this.$active, { initialValue: undefined })

    private ContactPersonCreated = new Subject<void>();

    constructor(protected override http: HttpClient, private router: Router) {
        super(http, APIRequestResources.ContactPersonService)
    }

    find = (searchParams: any, refresh = true) => {
        return this.get<PaginationResponse<ContactPersonFindDTO[]>>({
            endpoint: `find`,
            params: searchParams,
        }).pipe(
            tap((res) => {
                if (refresh) {
                    this.$all.next(res.data.data);
                }
            })
        );
    }

    getById = (id: any, refresh = false) => {
        return this.get<ContactPersonDTO>({ id })
            .pipe(
                tap((res) => {
                    if (refresh) {
                        this.$active.next(res.data);
                    }
                }),
            );
    }


create = (payload: any) => {
  const options = {};
      return this.post<any>(payload,options)
        .pipe(
            tap(() => this.notifyContactPersonCreated())
        );
}

    toggleContactPersonStatus(contactPersonId: any, payload: any) {
    const options = { 
      endpoint: 'active',
      suffix: contactPersonId.toString() 
    };
    return this.patch<any>(payload, options);
  }



    setActive(contactPerson: ContactPersonDTO) {
        this.$active.next(contactPerson);
    }

    notifyContactPersonCreated() {
        this.ContactPersonCreated.next();
    }

    onContactPersonCreated() {
        return this.ContactPersonCreated.asObservable();
    }

    initial = () => {
        this.$active.next(undefined)
    }
}